import React, { useEffect, useState } from "react";
import { Table, Space, Switch, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useVehicleModel } from "../vehicleModel";
import { IVehicleDetail } from "../vehicleType";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { momentFormat } from "@/utils/utils";
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";
import moment from "moment";

export function DataTable() {
    const { getSelectedNavState, switchNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const {
        dataSource, selectedRowKeys, pgCfg, initPgCfg,
        loadData, setSelectedRowKeys, onDisabled, updateSearchParam
    } = useVehicleModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const onLook = (code: string) => {
        let supplierEditKey = "13-5-2-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: code, mode: "look", },
            true
        );
    }
    const columns: ColumnsType<IVehicleDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (text, record, index) => `${index + 1}`
        }, {
            title: '客户名称',
            width: 230,
            dataIndex: 'customerName',
            render: (text: any) => <YhTootip text={text} style={{ width: '230px' }} />,
        }, {
            title: '下次保养时间',
            width: 140,
            dataIndex: 'nextMaintenanceTime',
            render: (text) => {
                const formattedTime = momentFormat(text);
                const currentTime = moment();
                const expectedTime = moment(formattedTime);
                const isOverdue = currentTime.isAfter(expectedTime);
                return isOverdue ? (
                    <span style={{ color: '#ff4d4f', fontWeight: 'bold' }}>{formattedTime}</span>
                ) : formattedTime;
            }
        }, {
            title: '部门',
            width: 120,
            dataIndex: 'depName',
            render: (text: any) => <YhTootip text={text} style={{ width: '120px' }} />,
        }, {
            title: '车辆牌照',
            width: 160,
            dataIndex: 'licensePlate',
            render: (text: any, record: any) => <YhTootip text={text} onClick={(e) => onLook(record.id)} />,
        }, {
            title: '车辆品牌',
            width: 160,
            dataIndex: 'brandName',
            render: (text: any) => <YhTootip text={text} style={{ width: '160px' }} />,
        }, {
            title: '车辆类型',
            width: 150,
            dataIndex: 'vehicleTypeName',
            render: (text: any) => <YhTootip text={text} style={{ width: '150px' }} />,
        },
        // {
        //     title: '车系',
        //     width: 160,
        //     dataIndex: 'series',
        // }, 
        {
            title: '车辆型号',
            width: 160,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: 'VIN码',
            width: 160,
            dataIndex: 'vin',
        }, {
            title: '创建人',
            width: 120,
            dataIndex: 'createUser',
        }, {
            title: '创建时间',
            width: 120,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '操作',
            width: 160,
            dataIndex: 'enable',
            render: (text, record) => (
                <Space size="middle">
                    {/* checked={record.materialStatus == 0} */}
                    <Switch checked={text == 1} onChange={(checked) => {
                        // onDisabled(record.id as string, checked);
                        onDisabled(record.id as string, checked);
                        // cutDisabled(record,checked)
                    }} />
                </Space>
            ),
        }
    ];
    useEffect(() => {
        if (detailsInfo) {
            let { parentInfo } = detailsInfo
            if (parentInfo) {
                loadData(initPgCfg, { customerName: parentInfo.customerName });
                updateSearchParam({ customerName: parentInfo.customerName })
                switchNavState("13-5-2", { id: "", mode: "add" })
            } else {
                loadData();
            }
        } else {
            loadData();
        }
        // console.log(detailsInfo)
    }, [detailsInfo]);

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            size={tableSize}
            rowKey={record => record.id as string}
            rowSelection={{
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: IVehicleDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id as string]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
